import React, {useState, useEffect} from 'react';

import Alert from '../../alert/alert';
import {loadUser} from '../alert-template-services';

export default ({alert, toggleNotificationRead, closeMenu, push}) => {
    let {giftLabel, ownedBy, originList, addedUserId} = alert.event.data;

    let [ownedByUser, setOwnedByUser] = useState();
    let [addedUser, setAddedUser] = useState();
    useEffect(() => {
        loadUser(ownedBy, setOwnedByUser);
        loadUser(addedUserId, setAddedUser);
    }, []);
    let originListLink = '/gift-tags/lists/' + originList;

    let message;
    if (ownedByUser && addedUser) {
        let addedUserName = addedUser.name.fullName;
        let ownerName = ownedByUser.name.fullName;
        message = <span><b>{addedUserName}</b> agreed to pitch in on the gift for <b>{ownerName}</b> - <b>"{giftLabel}"</b></span>
    }
    return (
        <Alert
            alert={alert}
            toggleNotificationRead={toggleNotificationRead}
            link={originListLink}
            closeMenu={closeMenu}
            push={push}
        >
            {message || 'Loading Message...'}
        </Alert>
    );
}